import { DeviceTypeEnum } from './deviceTypes'

export enum ImagePlaceholderTypesEnum {
  phonePlan = 'phonePlan',
  requests = 'requests',
  newOrderFlow = 'newOrderFlow',
}

export type ImagePlaceholderTypes = ImagePlaceholderTypesEnum | DeviceTypeEnum
